import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createEmploymentSyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.EMPLOYMENT_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            employment: {
                employeeType: 'fulltime',
                employmentStatus: 'active',
                jobTitle: 'Product Manager',
                startDate: '2017-04-19T12:00:00.000Z',
                minimumMonthsOfEmployment: 58,
                weeklyHours: 40,
                employer: {
                    name: 'Company Inc.',
                    address: {
                        line1: '12345 Enterprise Rd',
                        line2: 'Suite 105',
                        city: 'Salt Lake City',
                        state: 'UT',
                        postalCode: '84111',
                        country: 'USA'
                    }
                }
            },
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=employment-synced.js.map